import React, { useEffect, useState } from 'react'
import './index.scss'
import { modifyDiary, deleteDiary } from '../../../../api'
import Quill from 'quill'
import { Modal } from 'antd-mobile'
import qs from 'qs'

const { alert } = Modal

const { flutter } = qs.parse(window.location.search.substr(1)) as {
  flutter: string | undefined
}

const DetailBar: React.FC<{
  confirmInput: () => void
  refTasksCount: number
  isNote: Boolean
  setIsNote: React.Dispatch<React.SetStateAction<boolean>>
  title: string
  editorRef: React.MutableRefObject<Quill | null>
}> = ({ confirmInput, refTasksCount, isNote, setIsNote, title, editorRef }) => {
  const [recordId, setRecordId] = useState('')
  let [tipShow, setTipShow] = useState(false)

  useEffect(() => {
    setRecordId(window.localStorage.getItem('recordId') as string)
  }, [])

  async function linkMatter() {
    await confirmInput()
    const refTasks = window.localStorage.getItem('refTasks')

    if (flutter) {
      window.location = (`js://webview?trigger=link_matter&refTasks=${refTasks}&recordId=${recordId}` as unknown) as Location
      return
    }

    wx.miniProgram.redirectTo({
      url: `/pages/record/pages/add-relation-task/index?refTasks=${refTasks}&recordId=${recordId}&isH5=1`,
    })
  }

  function getShareContent() {
    let str = '',
      fileCount = 0

    editorRef.current?.getContents().ops.forEach(({ insert }) => {
      if (!insert) return
      if (typeof insert === 'string') {
        str += insert
        return
      }
      const {
        INSERT_FILE: { title, type, text },
      } = insert as {
        INSERT_FILE: { title?: string; type: InsertType; text: string }
      }

      const actions = {
        img: () => {
          fileCount += 1
          return '[图片]'
        },
        file: () => {
          fileCount += 1
          return `[${title}]`
        },
      } as { [k in InsertType]: () => string }

      str += actions[type] ? actions[type]() : text
    })

    return {
      desc: str,
      fileCount,
    }
  }

  function share() {
    modifyDiary({ share_state: 1 }, recordId).then(() => {
      if (flutter) {
        window.location = (`js://webview?trigger=share&recordId=${recordId}` as unknown) as Location
        return
      }
      wx.miniProgram.redirectTo({
        url: `/pages/contacts-selector/index?from=record&shareType=shareCard_note&recordId=${recordId}&shareFromH5=1&shareInfo=${JSON.stringify(
          {
            title,
            ...getShareContent(),
          }
        )}`,
      })
    })
  }

  function delDiary() {
    const tip = isNote
      ? '你确定要删除该记录吗？'
      : refTasksCount
      ? `删除后，关联事项中的记录也将被删除`
      : '你确定要删除该笔记吗？'

    alert('', tip, [
      {
        text: '不删除',
        onPress: () => console.log('cancel'),
      },
      {
        text: '删除',
        onPress: () => {
          deleteDiary(recordId).then(() => {
            if (flutter) {
              window.location = (`js://webview?trigger=delete` as unknown) as Location
              return
            }
            wx.miniProgram.postMessage({
              data: { setDiary: ['noteRemove', recordId] },
            })
            wx.miniProgram.navigateBack()
          })
        },
        style: 'destructive',
      },
    ])
  }

  function convertToDiary() {
    alert('', '将该记录转成笔记？', [
      { text: '不转成' },
      {
        text: '转成笔记',
        onPress: () => {
          modifyDiary({ record_type: 0 }, recordId).then(() => {
            if (flutter) {
              window.location = (`js://webview?trigger=convert_diary` as unknown) as Location
            }
            window.localStorage.removeItem('isNote')
            setIsNote(false)
          })
        },
      },
    ])
  }

  return (
    <div className="detail-bar">
      {!isNote && (
        <div className="link" onClick={linkMatter}>
          <img src="./images/icons/link.png" alt="" />
          <div>
            {refTasksCount ? `已关联${refTasksCount}个事项` : '关联事项'}
          </div>
          <img src="./images/icons/right.png" alt="" />
        </div>
      )}
      {isNote && (
        <div className="link link-convert">
          <span onClick={convertToDiary}>转成笔记</span>
          <img
            src="./images/icons/tip.png"
            alt=""
            className="icon-tip"
            onClick={() => setTipShow(!tipShow)}
          />
          {tipShow && (
            <div
              className="tip-box"
              id="tip-box"
              tabIndex={-1}
              onBlur={() => {
                setTipShow(false)
              }}
              ref={(input) => {
                input?.focus()
              }}
            >
              <img
                src="./images/icons/triangle.png"
                className="triangle"
                alt=""
              />
              <div className="tip-box-title">
                <img src="./images/icons/diary-write.png" alt="" />
                事项记录
              </div>
              <ul>
                <li>仅属于该事项的个人记录</li>
                <li>不支持分享</li>
              </ul>
              <div className="tip-box-title" style={{ marginTop: '11px' }}>
                <img src="./images/icons/diary-share.png" alt="" />
                笔记
              </div>
              <ul>
                <li>可在笔记列表中找到</li>
                <li>支持分享给好友</li>
                <li>最多可关联9个不同的事项</li>
              </ul>
            </div>
          )}
        </div>
      )}
      <div className="tools">
        {!isNote && (
          <img src="./images/icons/share.png" alt="" onClick={share} />
        )}
        <img src="./images/icons/trash.png" alt="" onClick={delDiary} />
      </div>
    </div>
  )
}

export default DetailBar
